import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }) => {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Skip redirect checks on the verify-email page itself to prevent loops
    if (location.pathname === '/verify-email') {
      console.log('skipping redirect checks on verify-email page');
      return;
    }

    if (!isLoggedIn) {
      navigate('login', {
        state: {
          from: location.pathname
        },
        replace: true
      });
    } else if (user.emailVerified === false) {
      console.log(user.emailVerified);
      console.log(location.pathname);
      console.log('navigating to verify-email');

      navigate('/verify-email', { replace: true });
    } else {
      // User is logged in, set consent status to granted
      if (window.gtag) {
        window.gtag('consent', 'update', {
          ad_storage: 'granted',
          analytics_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted'
        });
      }
      localStorage.setItem('consentStatus', 'granted');
    }
  }, [isLoggedIn, user, navigate, location]);

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
